<template>
  <div>
    <div class="container-fluid right_wrapper">
      <AsinScraperListHeader @getList="getList" @toggleLoader="toggleLoader"></AsinScraperListHeader>
      <div
        class="spinner-border"
        style="margin: auto; display: block; margin-top: 60px"
        v-if="loader"
      />
      <div v-show="!loader">
        <div>
          <AsinScraperListGrid
            ref="asinscrapper"
            @getList="getList"
            class="table_wrap"
            v-if="list && list.length"
          ></AsinScraperListGrid>
          <div
            class="dropup"
            v-if="selectedProducts && selectedProducts.length > 0"
          >
            <div
              class="bulk_action dropdown-toggle"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="text">Bulk Actions</span>
            </div>
            <AsinScrapperAction
              @getList="getList"
              @showLoader="showLoader"
              @resetSelected="resetSelected"
            />
          </div>
          <AsinScraperListGridFooter
            class="main_footer_wrap"
            @getList="getList"
            v-if="list && list.length"
          ></AsinScraperListGridFooter>
        </div>
        <NoDataAvailable
          displayMessage="No Data Is Available"
          v-if="!loader && !(list && list.length > 0)"
        ></NoDataAvailable>
      </div>
    </div>
  </div>
</template>

<script>
import AsinScraperListGrid from "@/components/asin-scraper/AsinScraperListGrid";
import AsinScraperListGridFooter from "@/components/asin-scraper/AsinScraperListGridFooter";
import AsinScraperListHeader from "@/components/asin-scraper/AsinScraperListHeader";
import AsinScrapperAction from "@/components/asin-scraper/AsinScrapperAction";
import NoDataAvailable from "@/components/NoDataAvailable.vue";

export default {
  name: "AsinScraperList",
  data() {
    return {
      loader: false,
      list: [],
    };
  },
  components: {
    AsinScraperListGrid,
    AsinScraperListGridFooter,
    AsinScraperListHeader,
    AsinScrapperAction,
    NoDataAvailable,
  },
  watch: {
    sort() {
      this.getList();
    },
  },
  mounted() {
    this.$store.dispatch("callAnalytics", {
      data: window.location.href,
      this: this,
      type: "asinScraperList",
    });

    if (this.$store.state.calledFromCancel) {
      this.$store.state.calledFromCancel = false;
    } else {
      this.getList();
      this.$store.dispatch("getVendorForNameList");
    }
    this.sort = {
      field: "updated_on",
      order: "desc",
    };
  },
  computed: {
    sort: {
      set(val) {
        this.$store.commit("setSelectedSortOrder", val);
      },
      get() {
        return this.$store.state.selectedSortOrder;
      },
    },
	selectedProducts: {
      set(val) {
        this.$store.state.product.selectedProducts = val;
      },
      get() {
        return this.$store.state.product.selectedProducts;
      },
    },
  },
  methods: {
    getList() {
      this.loader = true;
      let vm = this;

      this.$store.dispatch("asinScapper/getScrapperList").then((res) => {
        vm.loader = false;
        vm.list = res;
      });
    },
    toggleLoader(state){
      this.loader = state;
    },
    showLoader() {
      this.loader = true;
    },
    resetSelected() {
      this.$refs["asinscrapper"].resetSelectAllProduct();
    },
  },
  beforeDestroy() {
    this.sort = {
      field: "name",
      order: "asc",
    };
  },
};
</script>

<style lang="scss">
</style>
